module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/79793f7bd636a699839322d6e55c4c46.png";